import httpClient from '@/apis/base/httpclient';
import BaseAPI from '@/apis/base/baseApi';

class UserAPI extends BaseAPI {
  constructor() {
    super();
  }
  apiName = "TaskGo";
  controllerName = 'DocumentSigners';

  /**
   * Lấy danh sách người ký gợi ý
   * @param {number} organizationUnitID ID đơn vị
   * @author: BMThang(29/03/2023)
   */
  getDocumentSignersByOrganizationUnitID(organizationUnitID) {
    let request = {
      url: `${this.getAPIUrl()}/organization-unit-id/${organizationUnitID}`,
    };
    return httpClient.getAsync(request);
  }

  /**
   * Lấy danh sách người ký đã tồn tại
   * @param {number} organizationUnitID ID đơn vị
   * @author: BMThang(29/03/2023)
   */
  getExistedDocumentSignersByOrganizationUnitID(organizationUnitID) {
    let request = {
      url: `${this.getAPIUrl()}/existed/${organizationUnitID}`,
    };
    return httpClient.getAsync(request);
  }

  /**
   * Lấy danh sách người ký gợi ý
   * @param {object[]} documentSigners Danh sách người ký
   * @author: BMThang(29/03/2023)
   */
  saveMultipleDocumentSigner(documentSigners) {
    let request = {
      url: `${this.getAPIUrl()}/multiple`,
      data: documentSigners,
    };
    return httpClient.postAsync(request);
  }

  /**
   * Xóa người ký gợi ý theo ID
   * @param {string} documentSignerID ID người ký
   * @author: BMThang(29/03/2023)
   */
  deleteDocumentSignerByID(documentSignerID) {
    let request = {
      url: `${this.getAPIUrl()}`,
      data: {
        Id: documentSignerID,
      }
    };
    return httpClient.deleteAsync(request);
  }
}

export default new UserAPI();
